// extracted by mini-css-extract-plugin
export default {"phrases":"SayPhraseOrConfirmation_phrases__s1299"};